import * as types from 'constants/actionTypes';
import initialState from './initialState';

export default function reportReducer(state = initialState.reports, action) {
    switch (action.type) {
        case types.GOT_ANNUAL_SALES: {
            return {
                ...state,
                annualSales: [
                    ...action.data
                ]
            };
        }
        case types.GOT_PRODUCT_SALES: {
            return {
                ...state,
                productSales:
                    action.data

            };
        }
        case types.GOT_PRODUCT_RANKING: {
            return {
                ...state,
                baseStore: action.data.baseStore,
                compareTo: action.data.compareTo,
                totalRow: action.data.totalRow
            };
        }
        case types.GOT_PURCHASE_ORDER_REPORT: {
            return {
                ...state,
                purchaseorderReport:
                    action.data

            };
        }

        // Monthly Product Sales
        case types.GOT_MONTHLY_PRODUCT_SALES: {
            return {
                ...state,
                monthlyProductSales: [
                    ...action.data
                ]
            };
        }

        // Employee Time Sheet
        case types.GOT_EMPLOYEE_TIMESHEET: {
            return {
                ...state,
                employeeTimesheet: [
                    ...action.data
                ]
            };
        }

        //GOT Employee total hours
        case types.GOT_EMPLOYEE_HOURS: {
            return {
                ...state,
                employeeTotalHours: [
                    ...action.data
                ]
            };
        }

        case types.GOT_CUSTOMER_SALES: {
            return {
                ...state,
                customerSales: [
                    ...action.data
                ]
            };
        }

        case types.GOT_MANUAL_INVENTORY_CHANGE: {
            return {
                ...state,
                manualInventoryChange: [
                    ...action.data
                ]
            };
        }

        case types.GOT_DAILY_CASH_SUMMARY: {
            return {
                ...state,
                dailyCashSummary: action.data
            };
        }

        case types.GOT_AGGREGATE_SALES: {
            return {
                ...state,
                aggregateSales: [
                    ...action.data
                ]
            };
        }

        case types.GOT_AGGREGATE_INVENTORY: {
            return {
                ...state,
                aggregateInventory: [
                    ...action.data
                ]
            };
        }

        case types.GOT_PRODUCT_VELOCITY: {
            return {
                ...state,
                productVelocity:
                    action.data

            };
        }

        case types.GOT_REVENUE_REPORT: {
            return {
                ...state,
                revenueReport: {
                    ...action.data
                }
            };
        }

        case types.GOT_COMBINED_SALES_REPORT: {
            return {
                ...state,
                combinedSales: {
                    ...action.data
                }
            };
        }

        case types.GOT_SALES_BY_TYPE: {
            return {
                ...state,
                salesByType:
                    action.data

            };
        }

        case types.GOT_PROFIT_REPORT: {
            return {
                ...state,
                profitReport:
                    action.data

            };
        }

        case types.GOT_PRODUCT_PRICE_CHANGE_REPORT: {
            return {
                ...state,
                productPriceChangeReport:
                    action.data

            };
        }

        case types.GOT_AGGREGATE_BRANCHES_REPORT: {
            return {
                ...state,
                aggregateBranches:
                    action.data

            };
        }

        case types.GOT_TRANSACTION_SALES_SUMMARY: {
            return {
                ...state,
                transactionSalesSummary:
                    action.data

            };
        }

        case types.GOT_END_OF_DAY_REPORT: {
            return {
                ...state,
                endOfDay: {
                    ...action.data
                }
            };
        }

        case types.GOT_GENERAL_REPORT: {
            return {
                ...state,
                generalReport: {
                    ...action.data
                }
            };
        }

        case types.GOT_REORDER_REPORT: {
            return {
                ...state,
                reorder: {
                    ...action.data
                }
            };
        }

        case types.GOT_SALES_DAILY_REPORT: {
            return {
                ...state,
                dailySalesReport:
                    action.data

            };
        }

        case types.GOT_SALES_MONTHLY_REPORT: {
            return {
                ...state,
                monthlySalesReport:
                    action.data

            };
        }

        case types.GOT_PROFIT_DAILY_REPORT: {
            return {
                ...state,
                dailyProfitReport:
                    action.data

            };
        }

        case types.GOT_PROFIT_MONTHLY_REPORT: {
            return {
                ...state,
                monthlyProfitReport:
                    action.data

            };
        }

        case types.GOT_SALES_YEARLY_REPORT: {
            return {
                ...state,
                yearlySalesReport:
                    action.data

            };
        }

        case types.GOT_PROFIT_YEARLY_REPORT: {
            return {
                ...state,
                yearlyProfitReport:
                    action.data

            };
        }

        case types.GOT_GMROI_REPORT: {
            return {
                ...state,
                gmroi: [
                    ...action.data
                ]
            };
        }

        case types.GOT_SHOPPING_TREND: {
            return {
                ...state,
                shoppingTrend:
                    action.data
            };
        }

        case types.GOT_BUDGET_PLANNER_REPORT: {
            return {
                ...state,
                budgetPlanner:
                    action.data
            };
        }

        case types.GOT_SELL_THROUGH_REPORT: {
            return {
                ...state,
                sellThrough: [
                    ...action.data
                ]
            };
        }

        case types.GOT_HOURLY_SALES: {
            return {
                ...state,
                hourlySales: [
                    ...action.data
                ]
            };
        }

        case types.GOT_HOURLY_SALES_DATE_RANGE: {
            return {
                ...state,
                hourlySalesDateRange: {
                    ...action.data
                }
            }
        }

        case types.GOT_HOURLY_SALES_SECONDARY: {
            return {
                ...state,
                hourlySalesSecondary: [
                    ...action.data.list
                ],
                hourlySalesSecondaryTotal: {
                    ...action.data.totals
                }
            };
        }

        case types.GOT_WAREHOUSE_TRANSFER_REPORT: {
            return {
                ...state,
                warehouseTransfer: {
                    ...action.data
                }
            };
        }

        case types.GOT_DISCOUNT_REPORT: {
            return {
                ...state,
                discountReport:
                    action.data

            };
        }

        case types.GOT_DEMOGRAPHIC_REPORT: {
            const { demographicReportGender = [], demographicReportAge = [], totalMembers = 0 } = action.data || {}

            return {
                ...state,
                demographicReportGender,
                demographicReportAge,
                totalMembers,
                demographicReportTimeStamp: new Date().toString()
            };
        }

        case types.GOT_DELIVERY_REPORT: {
            return {
                ...state,
                deliveryReport: action.data
            };
        }

        case types.GOT_INVENTORY_LEVEL: {
            return {
                ...state,
                inventoryLevel: [...action.data]
            };
        }

        case types.GET_INVENTORY_AGE_SUCCESS: {
            return {
                ...state,
                inventoryAge: action.data
            }
        }

        case types.GET_RESTOCK_BY_CAPS_SUCCESS: {
            return {
                ...state,
                restockbyCaps: action.data
            }
        }

        case types.GOT_PRICE_TRACKER: {
            return {
                ...state,
                priceTracker: action.data
            };
        }


        case types.GOT_THCCBD_TRACKER: {
            return {
                ...state,
                tHCCBDTracker: action.data
            };
        }

        case types.GOT_CREDIT_PAYMENTS: {
            return {
                ...state,
                creditPayments: action.data
            };
        }
        
        case types.GOT_GIFT_CARD_BALANCE: {
            return {
                ...state,
                giftCardBalance: action.data
            };
        }

        case types.GOT_INVENTORY_SNAP_SHOT:
        case types.GOT_INVENTORY_SNAP_SHOT_PRODUCT_VIEW: {
            return {
                ...state,
                inventorySnapShot: [
                    ...action.data.list
                ],
                totalValueFromLatestCost: action.data.totalValueFromLatestCost,
                totalValueFromWAC: action.data.totalValueFromWAC,
                InventorySnapshotTotalRow: action.data.totalRow
            }
        }

        case types.GOT_MONTHLY_INVENTORY: {
            return {
                ...state,
                monthlyInventory: [
                    ...action.data
                ]
            }
        }

        case types.GET_AGGREGATE_INVENTORY_LEVEL_SUCCESS: {
            return {
                ...state,
                aggregateInventoryLevel: action.data.list
            }
        }

        case types.GOT_TAX_SUMMARY: {
            return {
                ...state,
                taxSummary:
                    action.data

            };
        }

        case types.GOT_CATEGORY_SALES: {
            return {
                ...state,
                categorySales:
                    action.data

            };
        }

        case types.GOT_SALES_SUMMARY: {
            return {
                ...state,
                salesSummary: action.data
            };
        }


        case types.GOT_EMPLOYEE_ACTIVITY: {
            return {
                ...state,
                transactionSummary: [
                    ...action.data
                ]
            };
        }

        case types.GOT_TRANSACTION_SUMMARY_BY_BUDTENDER: {
            return {
                ...state,
                budtenderAvgSales: {
                    ...action.data
                }
            };
        }

        case types.GOT_BRAND_SALES: {
            return {
                ...state,
                brandSales: action.data
            };
        }

        case types.GOT_INSTORE_ONLINE_SALES: {
            return {
                ...state,
                instoreOnlineSales: action.data
            };
        }

        case types.GOT_ORDER_LIST_SALES: {
            return {
                ...state,
                orderListSales: {
                    ...action.data
                }
            };
        }

        case types.GOT_CATEGORY_PRODUCTS: {
            return {
                ...state,
                categoryProducts:
                    action.data

            };
        }

        case types.GOT_GIFT_CARD_REPORT: {
            return {
                ...state,
                giftCardReport: action.data
            };
        }

        // Added for Shift by Employee Report (by Kate 2018-04-03 2:36PM)
        case types.GOT_SHIFT_BY_EMPLOYEE: {
            return {
                ...state,
                shiftByEmployee: [
                    ...action.data
                ]
            };
        }

        case types.GOT_DESTROYED_PRODUCT_REPORT: {
            return {
                ...state,
                destroyedProductReport: [
                    ...action.data
                ]
            };
        }

        case types.GOT_DISCREPANCY_REPORT: {
            return {
                ...state,
                discrepancyReport: [
                    ...action.data
                ]
            };
        }

        case types.DOWNLOAD_FEDERALREPORT_SUCCESS: {
            return {
                ...state,
                federalReport: [
                    ...action.data
                ]
            };
        }

        case types.GOT_PURCHASE_RECEIVER: {
            return {
                ...state,
                poReceiverReport: [
                    ...action.data
                ]
            };
        }

        case types.GET_INVENTORY_MOVEMENT_REPORT_SUCCESS: {
            return {
                ...state,
                inventoryMovement: [
                    ...action.data
                ],
                inventoryMovementProductInfo: action.inventoryMovementProductInfo
            }
        }

        case types.GET_INVENTORY_LOG_REPORT_SUCCESS: {
            return {
                ...state,
                inventoryLog: [
                    ...action.data
                ]
            }
        }

        case types.GET_SALES_SUMMARY_WITH_DETAILS_SUCCESS: {
            return {
                ...state,
                salesSummaryDetails: {
                    ...state.salesSummaryDetails,
                    data: action.data,
                    categoryFiltersSelected: action.categoryFiltersSelected,
                    orderTypeFiltersSelected: action.orderTypeFiltersSelected
                }
            }
        }

        case types.GET_AGGREGATE_BRANCH_SALES_INVENTORY_SUCCESS: {
            return {
                ...state,
                aggregateBranchSalesInventory: {
                    ...state.aggregateBranchSalesInventory,
                    data: action.data,
                    prevPeriodData: action.prevPeriodData,
                    selectedDateRangeType: action.selectedDateRangeType,
                    includeInventoryValue: action.includeInventoryValue
                }
            }
        }

        case types.GET_AUDIT_REPORT_SUCCESS: {
            return {
                ...state,
                auditReport: [
                    ...action.data
                ]
            }
        }

        case types.GET_UNCOUNTED_REPORT_SUCCESS: {
            return {
                ...state,
                uncountedReport: [
                    ...action.data
                ]
            }
        }
        case types.GET_SAGE_EXPORT_GUID_SUCCESS: {
            return {
                ...state,
                sageExportGuid: action.data
            }
        }
        case types.GET_INVENTORY_AT_DATE_GUID_SUCCESS: {
            return {
                ...state,
                inventoryAtDateGuid: action.data
            }
        }

        case types.REPORT_LOADING_COMPLETE: {
            return {
                ...state,
                reportLoadCompleteTimeStamp: new Date().getTime()
            }
        }

        case types.CLEAR_INVENTORY_CHART: {
            return {
                ...state,
                inventoryLevel: [],
                inventorySnapShot: []
            };
        }


        //IMPLEMENT ERROS AFTER HERE
        default: {
            return {
                ...state
            };
        }
    }
}
